// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"351":"commons","532":"styles","678":"component---src-pages-index-js","802":"94726e6d","883":"component---src-pages-404-js"}[chunkId] + "-" + {"351":"5245044f7de1fb24a5a0","532":"a962488c621434e0afcd","678":"b26061af4f081586ac83","802":"f0d12037e17ca699d1ef","883":"ed63b0c9cf49cc38ec23"}[chunkId] + ".js";
};